import React from 'react';
import classNames from 'classnames';
import ClipboardJS from 'clipboard';
import { LOGIN_TYPE, QQ_APPID, WX_APPID } from 'lib/constants/login';
import { loginByQQConnect, loginByWx } from 'lib/utils/login';
import UrlParams, { currentUrlParams } from 'lib/utils/url';
import storage from 'lib/utils/storage';
import { STORAGE } from 'lib/utils/storage/constants';
import toast from 'lib/utils/toast';
import { useDialogKeyboard } from 'lib/hooks/useDialogKeyboard';
import { closeModal, showModal } from '../Modal';
import './index.scss';

const ThirdPartyLogin = ({ isBinding = false, lastUserType = 0 }) => {
  useDialogKeyboard({ onEnter: false, onEscape: closeModal });

  const ua = window.navigator.userAgent.toLowerCase();
  const isWechatApp = /micromessenger/.test(ua);
  const isMiniProgram = /miniprogram/.test(ua);
  const qqLogin = () => {
    if (isMiniProgram) {
      const currentParams = currentUrlParams.getCurrentParams();
      const url = UrlParams.appendUrlParams(
        { ...currentParams, flowMobile: storage.getStorage(STORAGE.ORDER_MOBILE) },
        window.location.origin + window.location.pathname,
      );
      ClipboardJS.copy(url);
      toast.info('复制成功');
      return;
    }
    loginByQQConnect({
      appId: QQ_APPID.PROD,
    });
  };

  const wxLogin = () => {
    if (!isWechatApp) {
      const currentParams = currentUrlParams.getCurrentParams();
      const url = UrlParams.appendUrlParams(
        { ...currentParams, flowMobile: storage.getStorage(STORAGE.ORDER_MOBILE) },
        window.location.origin + window.location.pathname,
      );
      ClipboardJS.copy(url);
      toast.info('复制成功');
      return;
    }
    loginByWx({
      appId: WX_APPID,
    });
  };

  return (
    <div className="tp-login">
      <div className="tp-login__close" onClick={closeModal}>
        x
      </div>
      <div className="tp-login__header">{isBinding ? '绑定游戏账号' : '登录腾讯流量'}</div>
      <div className="tp-login__tips">QQ账号与微信账号不互通</div>
      <div
        className={classNames('tp-login__content', {
          'is-weixin': isWechatApp && !isMiniProgram,
        })}
      >
        <div className="login-item" onClick={qqLogin}>
          <div className="login-item__icon qq"></div>
          {isMiniProgram ? (
            <div className="login-item__desc tips">
              <p className="tips-head">QQ当前无法直接登录</p>
              <p>
                1.<span className="copy-btn">点击复制</span>发送给任意好友
              </p>
              <p>2.点击链接，即可使用QQ登录</p>
            </div>
          ) : (
            <div className="login-item__desc">
              <p>QQ登录</p>
              {lastUserType === LOGIN_TYPE.QQ ? <p className="last-login">(上次登录)</p> : ''}
            </div>
          )}
        </div>
        <div className="login-item" onClick={wxLogin}>
          <div className="login-item__icon wx"></div>
          {!isWechatApp ? (
            <div className="login-item__desc tips">
              <p className="tips-head">微信当前无法直接登录</p>
              <p>
                1.<span className="copy-btn">点击复制</span>发送给任意好友
              </p>
              <p>2.点击链接，即可使用微信登录</p>
            </div>
          ) : (
            <div className="login-item__desc">
              <p>微信登录</p>
              {lastUserType === LOGIN_TYPE.WX ? <p className="last-login">(上次登录)</p> : ''}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const showThirdPartyLogin = (props) => showModal(<ThirdPartyLogin {...props} />);

export default ThirdPartyLogin;
